import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { BillLineItem } from "@common/types/bill";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EditableCellContent } from "@design-system/ViewTable/EditableCellContent";
import { Amount } from "@design-system/Amount/Amount";
import { useAccrualAwareTableMeta } from "@hooks/view/accrualAwareTableMeta";
import { getBillLineOpenAmount } from "@common/helpers/accrual/openAmount";
import { BillLineItemsViewCallbacks } from "../types";

export const OpenAmountCell = memo(
    ({ row, table }: CellContext<ViewTableFeatures, BillLineItem, number>) => {
        const lineItem = row.original;
        const { callbacks, accrualEntityIds, isLoadingAccrualLedgers } =
            useAccrualAwareTableMeta<BillLineItemsViewCallbacks, BillLineItem>(
                table,
            );

        return (
            <ViewTableCell captureClicks>
                <EditableCellContent
                    onClick={() => callbacks?.onBillClick?.(lineItem)}
                    readonly
                >
                    {isLoadingAccrualLedgers ? (
                        "-"
                    ) : (
                        <Amount
                            amount={getBillLineOpenAmount(
                                lineItem,
                                accrualEntityIds,
                            )}
                        />
                    )}
                </EditableCellContent>
            </ViewTableCell>
        );
    },
);
